import { getReducerByDate } from './byDateReducer';

export const getBucketMetadata = (clusteredGroups: any) => {
  const toMetaDataByDate = getReducerByDate(clusteredGroups);
  return Object.keys(clusteredGroups).reduce(toMetaDataByDate, {});
};
